<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
	data () {
		return {
			seccion: 'porAgente'
		}
	},

	created () {
		const menu = [
			{
				'icono': 'fa fa-user',
				'nombre': 'Por agente',
				activo: true,
				'callback': (a) => {
					this.setMenuActivo(a)
					this.go('porAgente')
				}
			},
			{
				'icono': 'fa fa-users',
				'nombre': 'Por clientes',
				activo: false,
				callback: (a) => {
					this.setMenuActivo(a)
					this.go('porClientes')
				}
			}
		]
		this.setMenu(menu)
	},

	methods: {
		...mapMutations({
			setMenu: 'top/setMenu',
			setMenuActivo: 'top/setMenuActivo'
		}),
		go (seccion) {
			this.seccion = seccion
			this.$router.push('/main/facturacion/' + seccion)
		}
	}
}
</script>


<style scoped>
	.menuFacturacion {
		position: absolute;
		display: block;
		top: 0;
		left: 0;
		right: 0;
		overflow-x: auto;
	}
	.menuFacturacion > ul {
		position: relative;
		display: table;
		margin: 0;
		padding: 0;
		/*width: 100%;*/
	}

	.menuFacturacion > ul > li {
		position: relative;
		display: table-cell;
		text-align: center;
		height: 50px;
		padding: 15px;
		vertical-align: middle;
		cursor: pointer;
	}

	.menuFacturacion > ul > li:hover {
		background-color: #777777;
	}

	.menuFacturacion > ul > li.active {
		background-color: #f3f3f3;
		color: #444444;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/consultas-facturacion/vue/App.vue